// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lHk0","title":"styles_title__71EKb"};